var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme",class:{ selected: _vm.selected },attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.onThemeUpdate(_vm.theme)}}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":`images/icons/${_vm.theme.slug}.svg`}})]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.theme.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }